import { FunctionComponent } from 'react';
import Spinner, {
  SpinnerType,
} from 'src/designSystem/Spinner';

type Props = {
  type?: SpinnerType;
};

const PageSpinner: FunctionComponent<Props> = ({ type }) => {
  return <Spinner size="large" type={type} className="w-full h-full min-h-40" />;
};

export default PageSpinner;
